import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    eventoId: 0,

    importsParticipantes: [],
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,

    resultadoImportacion: 0
};

const mutations = {
    updateField,

    'INICIALIZAR' (state, eventoId) {
        state.eventoId = eventoId;
    
        state.importsParticipantes = [];
        state.paginaActual = 1;
        state.registrosPorPagina = 10;
        state.totalRegistros = 0;
        state.totalPaginas = 0;
    },
    'SET_IMPORTS' (state, importsParticipantes) {
        state.importsParticipantes = importsParticipantes;
    },
    'SET_PAGINATION'(state, params) {
        state.paginaActual = params.paginaActual;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
        state.totalPaginas = params.totalPaginas;
    },

    'INICIALIZAR_RESULTADOS_IMPORTACION' (state) {
        state.resultadoImportacion = 0;
    },
    'SET_RESULTADOS_IMPORTACION' (state, resultadoImportacion) {
        state.resultadoImportacion = parseInt(resultadoImportacion.cantidad);
    },
};

const getters = {
    getField,

    resultadoImportacion (state) {
        return state.resultadoImportacion;
    }
};

const actions = {
    inicializar ( { commit }, eventoId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR', eventoId);

            apiAxios.get(`eventos/${eventoId}/import-participantes`)
            .then(res => {
                commit('SET_IMPORTS', res.data);
                resolve();
            })
            .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    importar ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RESULTADOS_IMPORTACION');
            
            apiAxios.post(`eventos/${params.eventoId}/import-participantes/${params.importParticipantesId}/import`)
                .then(res => {
                    commit('SET_RESULTADOS_IMPORTACION', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    delete ( {}, params ) {
        return new Promise((resolve, reject) => {
            apiAxios.post(`eventos/${params.eventoId}/import-participantes/${params.importParticipantesId}/delete`)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}